// extracted by mini-css-extract-plugin
export default {"edit_part":"edit_edit_part__A3ykT","edit":"edit_edit__u911V"};